import script from "./BulkRemoveMemberAccountForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkRemoveMemberAccountForm.vue?vue&type=script&setup=true&lang=js"

import "./BulkRemoveMemberAccountForm.vue?vue&type=style&index=0&id=09955403&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09955403"]])

export default __exports__